import {
    formatProductValidationErrors,
    ProductValidationResult,
} from '@treez/commons/jsonSchema/products/product';
import React from 'react';
import styled from 'styled-components';
import {StoreAttributes} from '~/lib/directory';

interface Props {
    productValidationResult: ProductValidationResult;
    store: StoreAttributes | undefined;
    region: string | undefined;
}

const Container = styled.div`
    margin-bottom: 12px;
`;

const Store = styled.div`
    font-weight: bold;
`;

const Description = styled.div`
    text-align: center;
    margin-bottom: 12px;
`;

const Errors = styled.div`
    margin: 4px 12px;
    font-style: italic;
`;

const ProductValidationErrorMessage = (props: Props) => {
    const {productValidationResult, store, region} = props;

    return (
        <Container>
            <Store>{store?.name}</Store>
            <Description>
                This product does not meet the region requirements for {region}:
            </Description>
            <Errors>{formatProductValidationErrors(productValidationResult.errors)}</Errors>
        </Container>
    );
};

export default ProductValidationErrorMessage;
